export const DEFAULT_STRIPE_ACCOUNT_NUMBER = 5804
export const DEFAULT_STRIPE_ACCOUNT_NAME = 'Stripe'
